var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row d-flex justify-content-center" }, [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("div", { staticClass: "mb-4 text-center" }, [
          _c("h4", [
            _vm._v(_vm._s(_vm._f("translate")("Enter payment card details"))),
          ]),
        ]),
        _vm._v(" "),
        _c("CardForm", {
          attrs: {
            "show-component": "true",
            "public-rsa-prop": _vm.publicRsaProp,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "d-grid mt-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-dark",
              attrs: { disabled: _vm.loading },
              on: { click: _vm.submit },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Confirm and pay")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.has(_vm.errors, "cypher")
          ? _c("div", { staticClass: "text-danger mb-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("translate")("Card data is not valid")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.has(_vm.errors, "sale")
          ? _c("div", { staticClass: "text-danger mb-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("translate")(_vm.errors.sale[0])) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.has(_vm.errors, "membership")
          ? _c("div", { staticClass: "text-danger mb-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("translate")(_vm.errors.membership[0])) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "small mt-3" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm._f("translate")(
                  "When you update your card details, the system will collect the payment"
                )
              ) +
              ".\n      " +
              _vm._s(
                _vm._f("translate")("Thus extending access to the platform")
              ) +
              ".\n    "
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }